import { paths } from '@/config/paths';

/** Protected routes redirect to `/signin?next=<path>` (UI/UX interaction spec). */
export const RETURN_TO_PARAM = 'next';

/**
 * Accepts only same-origin, absolute in-app paths to prevent open redirects
 * (e.g. `?returnTo=https://evil.example` or `//evil.example`).
 */
export function getSafeReturnTo(value: string | null | undefined): string {
  if (!value?.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) {
    return paths.dashboard;
  }
  if (value.startsWith(paths.login) || value.startsWith(paths.forgotPassword)) {
    return paths.dashboard;
  }
  return value;
}

export function buildLoginUrl(returnTo?: string): string {
  if (!returnTo || returnTo === paths.home) return paths.login;
  return `${paths.login}?${new URLSearchParams({ [RETURN_TO_PARAM]: returnTo }).toString()}`;
}
